import React, { Context } from "react";
import { GQLReport } from "../../schemas/schema";

interface IReportEditContext {
  report: GQLReport
}

// @ts-expect-error
export const ReportEditContext: Context<IReportEditContext> = React.createContext({});
